import PropTypes from "prop-types";
import {
  AppBar,
  Box,
  Tab,
  Tabs,
  Toolbar,
} from "@mui/material";
import SplitButton from "./SplitButton"

const a11yProps = (index) => ({
  id: `simple-tab-${index}`,
  "aria-controls": `simple-tabpanel-${index}`,
});

const SalesTabsBar = ({
  disabled,
  onPageButtonClick,
  onPageTabChange,
  pageButtons,
  pageTabs,
  selectedTabIndex = 0,
}) => {
  const handleTabChange = (_, tabIndex) => {
    onPageTabChange?.({ tabIndex });
  };

  return (
    <AppBar position="static">
      <Toolbar variant="dense">
        <Tabs
          aria-label="Välj vad som ska visas"
          onChange={handleTabChange}
          value={selectedTabIndex}
        >
          {Array.isArray(pageTabs) && pageTabs.map((tab, index) => (
            <Tab
              disabled={disabled}
              key={index}
              label={tab.label}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
        <Box flexGrow={1} />
        <SplitButton
          disabled={disabled}
          onClick={onPageButtonClick}
          options={pageButtons}
        />
      </Toolbar>
    </AppBar>
  );
};

SalesTabsBar.propTypes = {
  disabled: PropTypes.bool,
  onPageButtonClick: PropTypes.func,
  onPageTabChange: PropTypes.func,
  pageButtons: PropTypes.array.isRequired,
  pageTabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      type: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedTabIndex: PropTypes.number,
};

SalesTabsBar.displayName = "SalesTabsBar";

export default SalesTabsBar;
